const UCG_LOGIN_URL = '/nccloud/mob/mobile/oauth/getToken';
const UCG_COMM_URL = '/nccloud/mob/mobile/common/api';
const UCG_UPLOAD_URL = '/nccloud/mob/mobile/file/upload';
const UCG_FORM_COMM_URL = '/nccloud/mob/mobile/common/formapi';

export {
    UCG_LOGIN_URL,
    UCG_COMM_URL,
    UCG_UPLOAD_URL,
    UCG_FORM_COMM_URL
}